define( function() {
	"use strict";

	return function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};

} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jquery@3.7.0@jquery/src/var/isWindow.js
// module id = vBaQ
// module chunks = 1